import React, {useEffect, useState} from 'react';
import {Link} from 'react-router-dom';
import { locale } from '../../utils/joyride';
import Joyride from "react-joyride";

const DetailGrammar = ({id, study, nextRun, trialPassed, passed, content}) => {
  const [run, setRun] = useState(false);

  console.log('nextRun', nextRun);
  console.log('run', run);

  useEffect(() => {
    setRun(!!(study && (!study.trialPassed || !study.final) && nextRun === 'grammar'));
  }, [nextRun]);

  useEffect(() => {
    window.listenAudio();
  }, []);

  return (
    <div className="row justify-content-center">
      <Joyride 
        run={run}
        locale={locale} 
        scrollOffset={80} 
        steps={trialPassed ? [
          {
            target: '.btn-final',
            content: 'Теперь нажмите "Завершить чтение"',
            disableBeacon: true,
          }
          
        ] : [
          {
            target: '.grammar-content',
            content: 'Изучите тему грамматики',
            disableBeacon: true,
          },
          {
            target: '.btn-trial',
            content: 'Нажмите на "Практическое занятие"',
            disableBeacon: true,
          },
        ]}
      />
      <div className="col-lg-9">
        <div className="mb-4 overflow-auto grammar-content" dangerouslySetInnerHTML={{__html: content}} />
        <div className="row gx-lg-3 gy-3">
          <div className="col-auto">
            <Link
              replace
              to={`/my-lessons/${id}/grammar/test`}
              className={`btn btn-trial btn-${trialPassed ? 'secondary' : 'primary'}`}
            >
              Практическое занятие {trialPassed ? '' : ''}
            </Link>
          </div>
          {trialPassed && (
            <div className="col-auto">
              <Link
                replace
                to={`/my-lessons/${id}/grammar/final-test`}
                className={`btn btn-final btn-${passed ? 'success' : 'primary'}`}
              >
                Пройти финальный тест{passed ? ' заново' : ' '}
              </Link>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default DetailGrammar;
